import React, { Component, createRef } from 'react';
import * as d3 from 'd3-selection';
import { func, string, number } from 'prop-types';

export default class Axis extends Component {

    static propTypes = {
        axis: func.isRequired,
        axisType: string.isRequired,
        customAxis: func,
        height: number.isRequired
    };

    constructor( props ) {

        super( props );
        this.axisRef = createRef();

    }

    componentDidMount() {

        this.renderAxis();

    }

    componentDidUpdate() {

        this.renderAxis();

    }

    renderAxis() {

        const g = d3.select( this.axisRef.current );

        g.call( this.props.axis );

        if ( this.props.customAxis ) {

            this.props.customAxis( g, this.props.axis );

        }


    }
    render() {

        // d3 creates the axis at top left of screen so move x axis down vertically by height of svg
        const translate = `translate(0,${ this.props.height })`;

        return (
            <g
                className={ `${ this.props.axisType }-axis` }
                ref={ this.axisRef }
                transform={ this.props.axisType === 'x' ? translate : '' }
            >
            </g>
        );

    }

}
